module.exports = __webpack_public_path__ + "static/img/env25.dd7a9b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env25.png
// module id = 115
// module chunks = 4